module.exports = __webpack_public_path__ + "img/ramus_logo.e4230f5f.png";